<template>
    <div class="treatment-analysis">
        <div v-if="hasGraphData" class="chart-card graph-card">
            <p class="chart-card-tit">治疗知识图谱</p>
            <knowledge-graph :graph-data="chartData.treatmentKnowledgeGraph" title="治疗知识图谱" height="420px" />
        </div>
        <div v-if="treatmentCharts.length" class="pie-panel">
            <div v-for="item in treatmentCharts" :key="item.field" class="chart-card">
                <p class="chart-card-tit">{{ item.title }} Top10</p>
                <disease-chart :option="item.option" height="280px" />
            </div>
        </div>
    </div>
</template>

<script>
import DiseaseChart from './disease_chart.vue';
import KnowledgeGraph from './knowledge_graph.vue';
import { TREATMENT_TYPES } from '../doctorData';


function buildPieOption(list) {
    return {
        tooltip: {
            trigger: 'item',
            formatter: '{b}: {c} ({d}%)',
        }, 
        // legend: {
        //     bottom: 0,
        //     textStyle: { color: '#5A6779', fontSize: 12 },
        // },
        legend: {
            type: 'scroll',
            left: 16,
            right: 16,
            bottom: 0,
            itemWidth: 14,
            itemHeight: 10,
            tooltip: { show: true },
            // data: seriesList.map((item) => item.name),
            textStyle: { color: '#5A6779', fontSize: 12, width: 120, overflow: 'truncate' },
        },
        series: [
            {
                type: 'pie', 
                center: ['50%', '50%'],
                data: list,
                radius: '52%',
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                },
                label: {
                    formatter: '{b}\n{d}%',
                    fontSize: 12,
                    color: '#333',
                },
                labelLine: {
                    length: 8,
                    length2: 6,
                }, 
                emphasis: {
                    itemStyle: {
                        shadowBlur: 8,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0,0,0,0.15)',
                    },
                },
            },
        ],
    };
}

export default {
    name: 'TreatmentAnalysis',
    components: {
        DiseaseChart,
        KnowledgeGraph,
    },
    props: {
        chartData: { type: Object, default: () => ({}) },
    },
    computed: {
        hasGraphData() {
            const graph = this.chartData.treatmentKnowledgeGraph;
            return !!(graph && graph.nodes && graph.nodes.length);
        },
        treatmentCharts() {
            return TREATMENT_TYPES.map((item) => {
                const list = this.chartData[item.field] || [];
                return { ...item, hasData: list.length > 0, option: buildPieOption(list) };
            }).filter((item) => item.hasData);
        },
    },
};
</script>

<style lang="less" scoped>
.treatment-analysis {
    .graph-card { margin-bottom: 16px; }

    .chart-card {
        min-width: 0;
        background: #fff;
        border: 1px solid #E8EEF8;
        border-radius: 10px;
        padding: 12px 14px 16px;
        box-sizing: border-box;
    }

    .pie-panel {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 16px;
    }

    .chart-card-tit {
        margin: 0 0 8px;
        font-size: 14px;
        font-weight: bold;
        color: #0C55AA;
        line-height: 20px;
    }
}
</style>
